// Recovered compiled webpack factory 2257. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n;
  r.d(t, {
    Bi: () => l,
    KU: () => p,
    m6: () => f,
    o5: () => u,
    rm: () => c,
    v4: () => d,
    vn: () => h,
  });
  var a = r(76636),
    o = r(60057),
    i = r(66941),
    s = r(17588);
  function l() {
    return void 0 !== n;
  }
  function u() {
    let e = (0, o.EU)();
    return (0, a.h)(e).getCurrentScope();
  }
  function c() {
    let e = (0, o.EU)();
    return (0, a.h)(e).getIsolationScope();
  }
  function f() {
    return (0, o.BY)("globalScope", () => new i.H());
  }
  function d(...e) {
    let t = (0, o.EU)(),
      r = (0, a.h)(t);
    if (2 === e.length) {
      let [t, n] = e;
      return t ? r.withSetScope(t, n) : r.withScope(n);
    }
    return r.withScope(e[0]);
  }
  function p() {
    return u().getClient();
  }
  function h(e) {
    let t = n?.();
    if (t) return { trace_id: t.traceId, span_id: t.spanId };
    let { traceId: r, parentSpanId: a, propagationSpanId: o } = e.getPropagationContext(),
      i = { trace_id: r, span_id: o || (0, s.Z)() };
    return (a && (i.parent_span_id = a), i);
  }
}
